// extracted by mini-css-extract-plugin
export default {"tooltip":"_1drq6g5"};